import { render, staticRenderFns } from "./Inplay.vue?vue&type=template&id=2e1972b4&scoped=true"
import script from "./Inplay.vue?vue&type=script&lang=js"
export * from "./Inplay.vue?vue&type=script&lang=js"
import style0 from "./Inplay.vue?vue&type=style&index=0&id=2e1972b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1972b4",
  null
  
)

export default component.exports